import { CxEvent } from '@spartacus/core';

export class GtmGgOrderPlacedEvent extends CxEvent {
  event?: string;
  transactionPostalCode?: string;
  transactionCountryName?: string;
  ecommerce?: {
    purchase?: {
      actionField?: {
        id?: string;
        affiliation?: string;
        revenue?: string;
        tax?: string;
        shipping?: string;
        coupon?: string;
      };
      products?: {
        id?: string;
        name?: string;
        category?: string;
        price?: string;
        brand?: string;
        variant?: string;
        quantity?: number;
      }[];
    };
  };
}
